// This script adds hover tooltips to glossary terms on the frontend
// and is injected in \Tidslinjer.Web\Views\Timeline.cshtml

(function () { 
  function isValidCssColor(value: string | null | undefined): value is string {
    return typeof value === "string"
      && value.trim().length > 0
      && typeof CSS !== "undefined"
      && typeof CSS.supports === "function"
      && CSS.supports("color", value.trim());
  }

  // Give glossary the same color as the timeline if specified in 'Markørfarve'-picker(property) from Umbraco Backoffice
  function getConfiguredGlossaryColor(): string | undefined {
    const root = document.documentElement;
    const body = document.body;
    const attrColor = root.getAttribute("data-glossary-color")
      || body?.getAttribute("data-glossary-color");

    if (isValidCssColor(attrColor)) {
      return attrColor.trim();
    }

    const rootStyles = window.getComputedStyle(root);
    const cssVarColor = rootStyles.getPropertyValue("--timeline-glossary-color")
      || rootStyles.getPropertyValue("--glossary-color");

    if (isValidCssColor(cssVarColor)) {
      return cssVarColor.trim();
    }
  }

  function injectStyles(): void {
    const styleId = "glossary-tooltip-styles";
    if (document.getElementById(styleId)) {
      return;
    }

    const style = document.createElement("style");
    style.id = styleId;
    style.textContent = `
      html body .ordforklaring {
        color: ${getConfiguredGlossaryColor()};
        cursor: pointer;
        text-decoration: none;
        position: relative;
        font-weight: 500;
      }

      html body .ordforklaring:hover {
        text-decoration: none;
      }

      .ord-tooltip {
        position: fixed;
        background: rgba(240,240,240,.9);
        box-shadow: 0 0 4px 0 rgba(0, 0, 0, .25);
        animation: tooltip-out 175ms ease-out forwards;
        color: #090C19;
        padding: 10px 15px;
        border-radius: 6px;
        font-size: 14px;
        line-height: 1.5;
        max-width: 300px;
        z-index: 10000;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
        pointer-events: none;
        opacity: 0;
        transition: opacity 0.2s ease-in-out;
      }

      .ord-tooltip.visible {
        opacity: 1;
      }

      .ord-tooltip::before {
        content: '';
        position: absolute;
        top: -6px;
        left: 20px;
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-bottom: 6px solid #333;
      }
    `;

    document.head.appendChild(style);
  }

  function ensureTooltipAfter(element: HTMLElement): HTMLDivElement {
    const next = element.nextElementSibling;
    if (next instanceof HTMLDivElement && next.classList.contains("ord-tooltip")) {
      return next;
    }

    const tooltip = document.createElement("div");
    tooltip.className = "ord-tooltip";
    tooltip.setAttribute("role", "tooltip");

    element.insertAdjacentElement("afterend", tooltip);
    return tooltip;
  }

  function positionTooltip(tooltip: HTMLElement, element: HTMLElement): void {
    const rect = element.getBoundingClientRect();
    const tooltipRect = tooltip.getBoundingClientRect();

    let left = rect.left + (rect.width / 2) - (tooltipRect.width / 2);
    let top = rect.bottom + 10;

    if (left < 10) {
      left = 10;
    }

    if (left + tooltipRect.width > window.innerWidth - 10) {
      left = window.innerWidth - tooltipRect.width - 10;
    }

    if (top + tooltipRect.height > window.innerHeight - 10) {
      top = rect.top - tooltipRect.height - 10;
      tooltip.classList.add("tooltip-above");
    } else {
      tooltip.classList.remove("tooltip-above");
    }

    tooltip.style.left = `${left}px`;
    tooltip.style.top = `${top}px`;
  }

  function showTooltip(tooltip: HTMLElement, element: HTMLElement, description: string): void {
    tooltip.textContent = description;
    tooltip.classList.add("visible");

    requestAnimationFrame(() => {
      positionTooltip(tooltip, element);
    });
  }

  function hideTooltip(tooltip: HTMLElement | null): void {
    if (!tooltip) {
      return;
    }

    tooltip.classList.remove("visible");
  }

  function isGlossaryTerm(element: EventTarget | null): element is HTMLElement {
    return element instanceof HTMLElement
      && ((element.classList && element.classList.contains("ordforklaring"))
      || element.hasAttribute("data-opslag"));
  }

  function initGlossary(): void {
    injectStyles();

    let activeTooltip: HTMLDivElement | null = null;
    let activeTerm: HTMLElement | null = null;

    document.addEventListener("mouseover", (event) => {
      const target = event.target;
      if (!isGlossaryTerm(target)) {
        return;
      }

      const description = target.getAttribute("data-description") || "";
      if (!description) {
        return;
      }

      activeTerm = target;
      activeTooltip = ensureTooltipAfter(target);
      showTooltip(activeTooltip, target, description);
    });

    document.addEventListener("mouseout", (event) => {
      const target = event.target;
      if (!isGlossaryTerm(target)) {
        return;
      }

      hideTooltip(activeTooltip);
      activeTooltip = null;
      activeTerm = null;
    });

    let scrollTimeout: number | undefined;
    document.addEventListener("scroll", () => {
      if (!activeTooltip || !activeTerm || !activeTooltip.classList.contains("visible")) {
        return;
      }

      window.clearTimeout(scrollTimeout);
      scrollTimeout = window.setTimeout(() => {
        if (activeTooltip && activeTerm) {
          positionTooltip(activeTooltip, activeTerm);
        }
      }, 10);
    }, true);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initGlossary);
  } else {
    initGlossary();
  }
})();